import { BeginCheckoutEventData } from '@/shared/thirdParty/gtm/types';
import { TCredit } from '@/shared/types/Billing';

import { getPricePerMin } from './getPricePerMin';

type GetBuyMinutesBeginCheckoutEventData = {
  price: number;
  product: TCredit;
  totalMinutes: number;
};

export const getBuyMinutesBeginCheckoutEventData = ({
  price,
  product,
  totalMinutes,
}: GetBuyMinutesBeginCheckoutEventData): BeginCheckoutEventData => {
  const { currency } = product.prices[0];
  return {
    ecommerce: {
      currency: currency.toUpperCase(),
      items: [
        {
          item_id: product.id,
          item_name: 'Minutes',
          price: getPricePerMin(product),
          quantity: totalMinutes,
        },
      ],
      value: price,
    },
  };
};
